import React from "react";
import styles from "./CarBranding.module.css";
import { Link } from "react-router-dom";
import DesignShowcase from "../../components/designShowcase/DesignShowcase";
import LineAnimation from "../../components/lineAnimations/LineAnimation";
import LineAnimationTwo from "../../components/lineAnimationsTwo/LineAnimationTwo";
import FAQ from "../../components/faq/Faq";

const CarBranding = () => {
  return (
    <>
      <div className={styles.pageBck}>
        <LineAnimation />
        <LineAnimationTwo />
        <div className={styles.pageBanner}>
          <h1>Brendimi i Makinave</h1>
          <span>CAR BRANDING</span>
          <p>
            Bold ofron branding profesional për të shndërruar automjetin tuaj në një reklamë në lëvizje. 
            Wraps të personalizuar që transformojnë dhe promovojnë biznesin tuaj 24/7.
          </p>
          <div className={styles.pageButtons}>
            <Link to="/contact">Na kontaktoni</Link>
          </div>
        </div>
      </div>

      <DesignShowcase
        reverse="reverse"
        image="/assets/images/car.jpg"
        title="Transformo Automjetin Tënd me Branding të Personalizuar të Makinave"
        text="Bold ofron branding profesional për të shndërruar automjetin tuaj në një reklamë në lëvizje..."
        keyOne="Wraps të Personalizuar – Pako tërheqëse të makinave të përshtatura për markën tuaj."
        keyTwo="Zgjidhje për Flotën – Branding i njëtrajtshëm në të gjitha automjetet."
        keyThree="Wraps Reflektues – Dizajne që duken gjatë 24/7 për dukshmëri maksimale."
      />

      <div className={styles.callUs}>
        <div className="subContainer">
          <h2>Gati për të nisur projektin tuaj?</h2>
          <Link to="/contact">Dërgo email</Link>
        </div>
      </div>

      <FAQ />
    </>
  );
};

export default CarBranding;

